import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/station_comment_replies',
  component: Management,
  redirect: '/station_comment_replies/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/station_comment_replies/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listStationComments
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/station_comment_replies/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/station_comment_replies/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'pending'
          }
        },
        {
          path: 'passed',
          component: () => import('@/views/station_comment_replies/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'passed'
          }
        },
        {
          path: 'rejected',
          component: () => import('@/views/station_comment_replies/ListTable'),
          meta: {
            auth: Auth.listStationComments,
            tabName: 'rejected'
          }
        }
      ]
    }
  ]
}
